<template>
  <div>
    <div v-if="busy" class="d-flex flex-column align-items-center mt-8 py-6">
      <spring-spinner
        :animation-duration="1500"
        :size="60"
        color="#bf0000"
        class="mx-auto"
      />
      <p class="primary--text mx-auto font-weight-bold mt-6">
        در حال بارگذاری...
      </p>
    </div>
    <div v-else>
      <pie-header :role="role" :allPies="allPies" />
      <!-- header -->
      <v-card class="custom-table pt-2">
        <v-row class="mb-4 mt-0 pt-0">
          <v-col class="d-flex" md="2" cols="12">
            <h4 class="mt-5">پرداختی‌های با حجم بالا</h4></v-col
          >
          <v-col md="3" cols="12">
            <div class="mt-3">
              <v-text-field
                outlined
                dense
                placeholder="جست‌و‌جو در نام"
                class="relative"
                prepend-inner-icon="mdi-magnify"
                v-model="filter"
              >
              </v-text-field>
            </div>
          </v-col>
          <!-- <v-col class="text-left"> <v-btn class="mt-3">خروجی csv <v-icon></v-icon></v-btn> </v-col> -->
          <v-col md="7" cols="12">
            <v-btn
              class="pa-5 border flex-row float-end mt-3"
              style="color: green"
              depressed
              @click="$refs.lumpSumTable.$el.click()"
              :disabled="!computedList.length"
            >
              <v-icon color="green" class="me-1">mdi-file-excel-outline</v-icon>
              خروجی اکسل
            </v-btn>
            <vue-excel-xlsx
              v-show="false"
              ref="lumpSumTable"
              :data="computedList"
              :columns="excelFields"
              :file-name="`پرداختی‌ها با حجم بالا_${currentDate}`"
              :sheet-name="'پرداختی‌ها با حجم بالا '"
            >
              دریافت اکسل
            </vue-excel-xlsx>
          </v-col>
        </v-row>

        <!-- end header -->
        <div class="custom-table pt-0">
          <v-data-table
            :mobile-breakpoint="0"
            :headers="headers"
            :items="computedList"
            hide-default-footer
            :page.sync="CurrentPage"
            :items-per-page="PerPage"
            class="pt-0 bold"
          >
            <template slot="no-data">
              <div class="font-weight-bold">موردی برای نمایش وجود ندارد!</div>
            </template>
            <template v-slot:[`item.description`]="{ item }">
              <span>{{ item.description ? item.description : "-" }}</span>
            </template>

            <!-- <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="primary"
                    ><span
                      @click="openDialog(item)"
                      class="pointer"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon class="white--text"
                        >mdi-trash-can-outline</v-icon
                      ></span
                    ></v-btn
                  >
                </template>
                <span>حذف</span>
              </v-tooltip>
            </template> -->
            <template v-slot:[`item.userName`]="{ item }">
              <span :style="'color:' + item.color">{{ item.userName }}</span>
            </template>
            <template v-slot:[`item.well`]="{ item }">
              {{
                item.well ? Number(item.well).toLocaleString() + "ریال" : "-"
              }}
            </template>
            <template v-slot:[`item.sliceCount`]="{ item }">
              {{ Number(item.sliceCount).toLocaleString() }}
            </template>
            <template v-slot:[`item.amount`]="{ item }">
              {{ Number(item.amount).toLocaleString() }} ریال
            </template>
          </v-data-table>
          <v-pagination
            v-model="CurrentPage"
            :length="Math.ceil(totalRows / PerPage)"
            :total-visible="5"
            prev-icon="mdi-arrow-left"
            next-icon="mdi-arrow-right"
            class="mt-8"
          ></v-pagination>
        </div>
        <v-dialog v-model="removeDialog" width="500">
          <v-card class="px-0">
            <v-card-title class="mb-4">
              حذف برداشت‌های با حجم بالا
            </v-card-title>
            <v-card-text>
              <p>آیا می‌خواهید برداشت‌های با حجم بالا حذف شود؟</p>
              <v-row class="mt-5">
                <v-col
                  class="d-flex flex-sm-row flex-column justify-space-between"
                >
                  <v-btn class="primary white--text mx-sm-0 mb-sm-0 mb-4">
                    <v-icon small>mdi-check-bold</v-icon>
                    بله
                  </v-btn>
                  <v-btn
                    class="primary white--text mx-sm-0"
                    @click="removeDialog = false"
                  >
                    <v-icon small>mdi-close-thick</v-icon>
                    خیر
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-card>
    </div>
  </div>
</template>
<script>
import { SpringSpinner } from "epic-spinners";
import utilities from "./../../mixins/utilities";
import moment from "moment-jalaali";
const PieHeader = () => import("@/components/PieHeader");
export default {
  components: {
    SpringSpinner,
    PieHeader,
  },
  mixins: [utilities],
  data() {
    return {
      moment: moment,
      currentDate: moment(new Date()).format("jYYYY-jMM-jDD"),
      busy: false,
      role: "",
      tableLoading: false,
      allPies: [],
      removeDialog: false,
      filter: "",
      CurrentPage: 1,
      PerPage: 10,
      totalRows: "",
      headers: [
        { text: "تاریخ", value: "date" },
        { text: "نام", value: "userName" },
        { text: "مبلغ پرداخت‌‌شده ", value: "amount" },
        { text: "توضیحات", value: "description" },
        { text: "قطعات", value: "sliceCount" },
        { text: "صندوق مالی", value: "well" },
        { text: "", value: "actions" },
      ],
      excelFields: [
        { label: "تاریخ", field: "date" },
        { label: "نام", field: "userName" },
        { label: "مبلغ پرداخت‌‌شده ", field: "amount" },
        { label: "توضیحات", field: "description" },
        { label: "قطعات", field: "sliceCount" },
        { label: "صندوق مالی", field: "well" },
        { label: "", field: "actions" },
      ],
      lumpsumData: [],
    };
  },
  methods: {
    goToPie(item) {
      this.$router.push("/home/" + item.id);
      localStorage.setItem("selectedPie", item.id);
      localStorage.setItem("role", item.userRole);
      localStorage.setItem("restriction", item.restriction);
      localStorage.setItem("ownerId", item.pieUserId);
    },
    openDialog(item) {
      this.removeDialog = true;
    },
    getData() {
      this.busy = true;
      this.$http
        .get(
          this.baseUrl +
            "/" +
            this.role +
            "/lumpsums/list/" +
            this.$route.params.id,
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            this.lumpsumData = res.data;
            this.totalRows = res.data.length;
            this.busy = false;
          } else {
            this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
            this.busy = false;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.busy = false;
        });
    },
    // getData() {
    //   this.lumpsumData = [
    //     {
    //       date: "1401/03/05",
    //       userName: "امیرحسین رحمانی",
    //       amount: 1000,
    //       description: "پرداخت خرید",
    //       sliceCount: "400",
    //       well: 0,
    //       color: "yellow",
    //     },
    //     {
    //       date: "1401/04/25",
    //       userName: "سینا اسدی",
    //       amount: 5000,
    //       sliceCount: "200",
    //       well: 10000,
    //       color: "blue",
    //     },
    //     {
    //       date: "1401/05/16",
    //       userName: "صبا فرهمند",
    //       amount: 100000,
    //       sliceCount: "220",
    //       well: 20000,
    //       color: "red",
    //     },
    //     {
    //       date: "1401/02/26",
    //       userName: "علیرضا صالحی",
    //       amount: 20000,
    //       sliceCount: "300",
    //       well: 5000,
    //       color: "purple",
    //     },
    //     {
    //       date: "1401/01/08",
    //       userName: "آرینا اشرفی",
    //       amount: 180000,
    //       sliceCount: "190",
    //       well: 8000,
    //       color: "orange",
    //     },
    //   ];
    //   this.totalRows = this.lumpsumData.length;
    // },
  },
  mounted() {
    this.role = localStorage.getItem("role");
    this.getData();
    this.getAllPies();
  },
  computed: {
    computedList() {
      let filtered = [];
      if (this.lumpsumData) {
        filtered = this.lumpsumData.filter((item) =>
          item.userName.includes(this.filter)
        );
      }
      return filtered;
    },
    computedCurrentPie() {
      if (this.allPies.length) {
        let pie;
        pie = this.allPies.filter((x) => x.id == this.$route.params.id)[0];
        return pie;
      }
    },
  },
};
</script>
